import { styled } from "../stitches";

import Box from "./Box";

const Grid = styled(Box, {
  display: "grid",
});

export default Grid;
